/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { AlertsIconWrapper } from '../alerts/alertsIconWrapper';
import { AirQualityIcon } from '../common/icons/airQualityIcon';

const defaultTextColor = '#555555';

interface AirQualityInfoContainerProps {
    backgroundFillColor: string;
    index: string;
    aqiDescription: string;
    aqiTodaysConditions: string;
    lastUpdatedTime: string;
}

export const AirQualityInfoContainer = memo(({ 
    backgroundFillColor,
    index,
    aqiDescription,
    aqiTodaysConditions,
    lastUpdatedTime
}: AirQualityInfoContainerProps) => {
    return (
        <InfoContainer>
            <TitleContainer>
                <AlertsIconWrapper>
                    <AirQualityIcon 
                        backgroundFillColor={backgroundFillColor} 
                        backgroundCircleWidth={34}
                        backgroundCircleHeight={34}
                        svgWidth={29}
                        svgHeight={29}  
                    />
                </AlertsIconWrapper>
                <TitleNumberContainer>{index}</TitleNumberContainer>
                <TitleWordContainer>{aqiDescription}</TitleWordContainer>
            </TitleContainer>
            <MessageContainer defaultTextColor={defaultTextColor}>
                <MessageBody>{aqiTodaysConditions}</MessageBody>
                <LastUpdatedBody>{lastUpdatedTime}</LastUpdatedBody>
            </MessageContainer>
        </InfoContainer>
    );
});

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 90%;
    align-items: center;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #555555;
`;

const TitleNumberContainer = styled.div`
    padding-top: 8px;
    :after {
        content: '';
        margin: 10px 0 0 5px;
        height: 60%;
        border-right: 2px solid black;
    }
`;

const TitleWordContainer = styled.div`
    padding: 8px 0 0 5px;
`;

interface MessageContainerProps {defaultTextColor: string;}
const MessageContainer = styled.div<MessageContainerProps>`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 24px 0 50px;
    color: ${props => { 
        return `${defaultTextColor}`;
    }};
    font-family: Source Sans Pro;
    font-weight: 400;
    white-space: pre-wrap;
`;

const MessageBody = styled.div`
    display: flex;
    flex-direction: row; 
    font-size: 16px;
`;

const LastUpdatedBody = styled.div`
    display: flex;
    flex-direction: row; 
    font-size: 12px;
    margin-left: auto;
    padding-top: 10px;
`;
